import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from './ActionButton/ActionButton';
import DeleteActionButton from './ActionButton/DeleteActionButton';
import EditActionButton from './ActionButton/EditActionButton';

const ActionButtons = props => {
  const { buttons = [], keyField, maxLabels, row = {}, showLabels } = props;

  const renderButtons = () => {
    const visibleButtons = buttons.filter(button => {
      switch (button.type) {
      case 'edit':
        return row.can_edit !== false;
      case 'delete':
        return row.can_delete !== false;
      default:
        return true;
      }
    });
    const showLabel = showLabels || visibleButtons.length <= maxLabels;

    return visibleButtons.map((button, index) => {
      let ButtonComponent = ActionButton;
      switch (button.type) {
      case 'edit':
        ButtonComponent = EditActionButton;
        break;
      case 'delete':
        ButtonComponent = DeleteActionButton;
        break;
      }
      return (
        <ButtonComponent
          {...props}
          {...button}
          key={index}
          keyField={keyField}
          row={row}
          showLabel={showLabel} />
      );
    });
  }

  return (
    <div className="action-buttons">
      {renderButtons()}
    </div>
  );
};

ActionButtons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      action: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      actionType: PropTypes.string.isRequired,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      download: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      iconFamily: PropTypes.string,
      iconTransform: PropTypes.string,
      icon: PropTypes.string,
      target: PropTypes.string,
      title: PropTypes.string,
      tooltip: PropTypes.string,
      type: PropTypes.oneOf(['edit', 'delete'])
    })
  ).isRequired,
  keyField: PropTypes.string,
  maxLabels: PropTypes.number,
  row: PropTypes.object.isRequired,
  showLabels: PropTypes.bool
};

ActionButtons.defaultProps = {
  maxLabels: 1
};

export default ActionButtons;
